var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagesWhiteColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12004_3052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16H0V4H16V16ZM0.551729 15.4462H15.4483V4.55387H0.551729V15.4462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 2H0V3H16V2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V0.827119H16V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12004_3052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesWhiteColor);
export default __webpack_public_path__ + "static/media/PagesWhiteColor.5f2aee90814ec673bfa59a86318a70bc.svg";
export { ForwardRef as ReactComponent };